import {
  SP_PASSWORD_SETUP_DEADLINE_MS_KEY,
  SP_PASSWORD_SETUP_REQUIRED_SESSION_KEY,
  SP_PENDING_INITIAL_PASSWORD_KEY,
} from './constants'

export function readPasswordSetupRequired(): boolean {
  if (globalThis.sessionStorage === undefined) return false
  try {
    return (
      globalThis.sessionStorage.getItem(SP_PASSWORD_SETUP_REQUIRED_SESSION_KEY) ===
      '1'
    )
  } catch {
    return false
  }
}

/** User must complete /set-password (post-signup TTL or forced setup flag). */
export function needsInitialPasswordSetupRoute(
  deadlineMs: number | null = readPasswordSetupDeadlineMs()
): boolean {
  if (readPasswordSetupRequired()) return true
  return (
    readPendingInitialPasswordSetup() &&
    isInitialPasswordSetupDeadlinePassed(deadlineMs)
  )
}

export function readPendingInitialPasswordSetup(): boolean {
  if (globalThis.sessionStorage === undefined) return false
  try {
    return globalThis.sessionStorage.getItem(SP_PENDING_INITIAL_PASSWORD_KEY) === '1'
  } catch {
    return false
  }
}

export function readPasswordSetupDeadlineMs(): number | null {
  if (globalThis.sessionStorage === undefined) return null
  try {
    const raw = globalThis.sessionStorage.getItem(SP_PASSWORD_SETUP_DEADLINE_MS_KEY)
    if (!raw) return null
    const parsed = Number(raw)
    return Number.isFinite(parsed) ? parsed : null
  } catch {
    return null
  }
}

export function isInitialPasswordSetupDeadlinePassed(
  deadlineMs: number | null = readPasswordSetupDeadlineMs()
): boolean {
  if (deadlineMs == null) return false
  return Date.now() >= deadlineMs
}

/** Guest routes for BFP-256 initial password via password-reset (Figma 5074-11995 → verify-otp → 5074-11486). */
export function isPasswordSetupGuestPath(pathname: string): boolean {
  if (pathname === '/forgot-password' || pathname === '/forgot-password/sent') {
    return true
  }
  if (pathname === '/verify-otp') return true
  if (pathname === '/reset-password' || pathname.startsWith('/reset-password/')) {
    return true
  }
  return false
}

export function isCompletingInitialPasswordSetup(
  passwordSetupRequired: boolean,
  passwordSetupDeadlineMs: number | null
): boolean {
  return (
    passwordSetupRequired ||
    needsInitialPasswordSetupRoute(passwordSetupDeadlineMs)
  )
}

export function persistPendingInitialPasswordSetup(
  pending: boolean,
  deadlineMs: number | null
) {
  if (globalThis.sessionStorage === undefined) return
  try {
    if (pending && deadlineMs != null) {
      globalThis.sessionStorage.setItem(SP_PENDING_INITIAL_PASSWORD_KEY, '1')
      globalThis.sessionStorage.setItem(
        SP_PASSWORD_SETUP_DEADLINE_MS_KEY,
        String(deadlineMs)
      )
    } else {
      globalThis.sessionStorage.removeItem(SP_PENDING_INITIAL_PASSWORD_KEY)
      globalThis.sessionStorage.removeItem(SP_PASSWORD_SETUP_DEADLINE_MS_KEY)
    }
  } catch {
    /* private mode / quota */
  }
}
